export const replaceCommas = (str?: string): string => (str ?? '').replace(',', '.').replace(/,/g, '');

export const removeApostrophes = (str: string): string => str.replace(/'/g, '');

const modifyFirstChar = (value: string, modifier: (char: string) => string): string => modifier(value.charAt(0)) + value.slice(1);

export const capitalizeWord = (value: string): string => modifyFirstChar(value, (char) => char.toUpperCase());

export const lowercaseWord = (value: string): string => modifyFirstChar(value, (char) => char.toLowerCase());

export { ellipsize } from '@/js/libs/ellipsize';

const NO_FILE_EXTENSION = 'none';

export const buildFileName = (name: string, extension: string | undefined): string =>
  extension && extension !== NO_FILE_EXTENSION ? `${name}.${extension}` : name;
